export const HEADER_TEXT = {
    title: "Scores across the board",
    description: 'Mean score by category and stakeholder group, shaded by distance from the row benchmark (All but Self).'
}

// Legend for the 6-point rating scale, shown in the "How to read the ratings"
// collapse. `tone` drives the red/green styling and must stay in sync with
// HeatmapV2's own `favorableMin: 4` threshold (see benchmarkStyle above).
export const RATINGS_LEGEND = {
    heading: 'How to read the ratings',
    subheading: '6-point scale · scores ≥ 4 are favorable',
    footnote: "Scores 1–2 = Unfavorable · Scores 3–6 = Favorable. The heatmap shades cells around this threshold.",
    scale: [
        { value: 1, label: 'Almost Never', range: '0–10%', tone: 'unfavorable' },
        { value: 2, label: 'Rarely', range: '10–30%', tone: 'unfavorable' },
        { value: 3, label: 'Occasionally', range: '30–50%', tone: 'favorable' },
        { value: 4, label: 'Sometimes', range: '50–70%', tone: 'favorable' },
        { value: 5, label: 'Usually', range: '70–90%', tone: 'favorable' },
        { value: 6, label: 'Almost Always', range: '90–100%', tone: 'favorable' },
    ],
}

// Compact key strip shown under the Heatmap description, explaining the cell
// shading, the favorable-threshold marker, the critical skill star, and row
// expansion.
export const HEATMAP_KEY = {
    shading: 'Shaded by distance from benchmark (All but Self) — red = below, green = above',
    threshold: 'Below favorable threshold (< 4)',
    critical: 'Critical skill (top-ranked by stakeholders)',
    expand: 'Click a category to expand.',
}